import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ReplaySubject} from 'rxjs';
import {RxComponent} from '../../../../../../core/components/common/rx.component';
import {CertificatesService} from '../../../certificates.service';
import {DynamicGridField} from '../../../../../../shared/components/dynamic-grid/dynamic-grid.component';

@Component({
    selector: 'itpx-certificate-used',
    templateUrl: './certificate-used.component.html',
    styleUrls: ['./certificate-used.component.css']
})
export class CertificateUsedComponent extends RxComponent implements OnInit {

    @Input() certificateTemplateId: string;

    gridRefresh = new ReplaySubject<boolean>(1);

    form: FormGroup;
    fields: DynamicGridField[];
    isCourse = true;
    url: string;
    emptyMessage: string;
    allCategories: { key: string, value: string }[];
    filterState: string;

    initialFilterState = '&categoryId=';
    options = [
        {key: 'courses', value: 'Courses'},
        {key: 'products', value: 'Products'}
    ];
    filterBox = {
        title: '',
        key: 'categoryId',
        options: [],
        config: {
            dropdownType: true
        }
    };

    get courseFields(): DynamicGridField[] {
        return [
            {
                title: 'Course Name',
                name: 'name',
                config: {
                    type: 'link',
                    route: '/course-management/courses/{{key}}/details',
                    key: 'id'
                },
                sortable: true,
            },
            {
                title: 'Course Type',
                name: 'format.configValue',
                sortable: true,
            },
            {
                title: 'Category',
                name: 'categoryName',
                sortable: true,
            }
        ];
    }

    get productFields(): DynamicGridField[] {
        return [
            {
                title: 'Product Name',
                name: 'name',
                config: {
                    type: 'template',
                    template: 'linkTemplate'
                },
                sortable: true,
            },
            {
                title: 'Product Type',
                name: 'type',
                sortable: true,
            },
            {
                title: 'Category',
                name: 'group.name',
                sortable: true,
            }
        ];
    }

    constructor(
        private fb: FormBuilder,
        private router: Router,
        private service: CertificatesService
    ) {
        super();
    }

    ngOnInit() {
        this.form = this.fb.group({
            type: ['courses', [Validators.required]]
        });

        this.toggleChanged();

        this.form.get('type').valueChanges
            .distinctUntilChanged()
            .bindToLifecycle(this)
            .subscribe(type => this.toggleChanged(true));
    }

    onProductLinkClicked(item: any): void {
        this.service.getProductDetailsBySKU(item.sku)
            .subscribe((productDetails: any) =>
                this.router.navigate(['/product-seller/' + productDetails.id + '/details']));
    }

    onFilterChanges(event) {
        this.filterState = this.initialFilterState;
        this.filterBox.options
            .map((option: { key: string, value: string }) => option.key)
            .forEach((option: string) => {
                if (event.status.categoryId === option) {
                    if (this.filterState !== this.initialFilterState) {
                        this.filterState += ',';
                    }
                    this.filterState += option;
                }
            })

        this.url = (this.isCourse ?
                this.service.getCertificatesLinkedCoursesURL(this.certificateTemplateId) :
                this.service.getCertificatesLinkedProductsURL(this.certificateTemplateId)
        ) + this.filterState;

        this.refreshGrid();
    }

    private toggleChanged(changed?: boolean): void {
        if (changed) {
            this.isCourse = !this.isCourse;
        }

        this.fields = this.isCourse ? this.courseFields : this.productFields;
        this.emptyMessage = 'No matching ' + (this.isCourse ? 'courses' : 'products') + '!';

        this.url = this.isCourse ?
            this.service.getCertificatesLinkedCoursesURL(this.certificateTemplateId) :
            this.service.getCertificatesLinkedProductsURL(this.certificateTemplateId);

        (this.isCourse ?
                this.service.getCourseCategoriesByCertificate(this.certificateTemplateId) :
                this.service.getProductCategoriesByCertificate(this.certificateTemplateId)
        ).subscribe((categories: {key: string, value: string}[]) => {
                this.allCategories = categories;
                this.filterBox = {
                    ...this.filterBox,
                    title: this.isCourse ? 'Course' : 'Product',
                    options: categories
                }
            }
        );

        this.refreshGrid();
    }

    private refreshGrid(): void {
        setTimeout(() => {
            this.gridRefresh.next(true)
        }, 50);
    }
}



// WEBPACK FOOTER //
// ./src/app/organization/components/certificates/components/details/certificate-used/certificate-used.component.ts